import MediaPlayer from './MediaPlayer'
import { useDispatch } from 'react-redux'
import SwipeCardOverlay from './SwipeCardOverlay'
import { useSwipeable } from 'react-swipeable'
import { useRef } from 'react'
import { isMediaFailed, isNoContent } from 'util/postUtils'
import MediaFailed from './MediaFailed'
import { setPlayListLiked } from 'util/playlistUtils'
import DisplayLog from 'components/utility/DisplayLog'
import NoContent from './NoContent'
import { track } from 'util/analyticsUtil'
import { ANALYTICS_EVENTS } from 'util/analyticsUtil'
import { getCurrentPlaylistName } from 'util/playlistUtils'
import VideoOverlay from './VideoOverlay'
import { store } from 'index'
import { PLAYER_MODES } from 'redux/reducers/harmonizeReducer'


export const ZINDEX_CONTROLS = 5000
export const ZINDEX_FULLSCREEN_VIDEO = 10000
const semiTransparent = 'rgba(0, 0, 0, 0.05)'
export const playerStyles = {
    controlIcon: {
        fontSize: '2em',
        color: 'white',
        marginTop: '1em',
        borderRadius: '10px',
        backgroundColor: semiTransparent
    },
    imageCard: {
        position: 'relative',
        color: 'white',
        aspectRatio: '9/16',
        height: '100vh'
    },
    playerIcon: {
        fontSize: '2em',
        color: 'white'
    },
    rhapPlayerIcon: {
        fontSize: '40px',
        width: '40px',
        height: '40px',
        color: '#868686'
    },
    /** This is to match the small reset-repeat icon in the default controls area */
    rhapAdditionalControlsIcon: {
        width: '26px',
        height: '26px',
        color: '#868686'
    },
    textArea: {
        zIndex: ZINDEX_CONTROLS,
        bottom: '10vh',
        paddingLeft: '1em',
        paddingRight: '1em',
        height: '50vh',
        display: 'flex',
        flexDirection: 'column',
        position: 'absolute',
        width: '100%',
        backgroundColor: 'white',
        overflowY: 'auto'
    }
}

export default function SwipeCard({ socket, setCollectionPlaylist }) {
    console.log(`\n---------- SwipeCard -------------`)

    const videoRef = useRef()
    const videoControlRef = useRef()
    const dispatch = useDispatch()

    /**
     * The only fullscreen support that works correctly on iOS is that implemented by
     * the video player itself. Since we cannot get the fullscreenchange event, we
     * set the zIndex for the contained display (meaning the entire video is shown
     * and not a crop) to 10000 which should be higher than the 5000 used for the 
     * controls. This causes the control panels to be hidden in fullscreen landscape
     * because the width and height for the video are both max (100vw, 100vh).
     * @returns 
     */
    const displayVideoPlayer = () => {
        return (
            <div ref={videoRef} style={{
                position: 'absolute', top: 0, left: 0,
                width: '100%'
            }}>
                <MediaPlayer
                    ref={videoControlRef}
                    dispatch={dispatch} />
            </div>

        )

    }

    const displayLog = () => {
        if (process.env.REACT_APP_SHOW_LOG === 'true') {
            return <DisplayLog />
        }
    }

    const displayNada = () => {
        return (
            <div style={{ position: 'relative' }}
            >
                <SwipeCardOverlay socket={socket}
                    setCollectionPlaylist={setCollectionPlaylist}
                />
                {isNoContent() ? <NoContent /> : <MediaFailed />}
                {/*displayLog()*/}
            </div>
        )
    }
    const displayMain = () => {
        if (isNoContent() || isMediaFailed()) {
            return displayNada()
        } else {
            const { playerMode } = store.getState().harmonize
            return (
                <div {...handlers} style={{ position: 'relative' }}
                >
                    <SwipeCardOverlay socket={socket}
                        controlRef={videoControlRef}
                        setCollectionPlaylist={setCollectionPlaylist}
                        enterFullscreen={videoControlRef ? () => videoControlRef.current.fullscreen() : null} />
                    {playerMode === PLAYER_MODES.VIDEO_ONLY ? <VideoOverlay />
                        : displayVideoPlayer()}
                    {/*displayLog()*/}
                </div>
            )

        }
    }

    const handlers = useSwipeable({
        swipeDuration: 250, //500,
        onSwipedUp: () => {
            videoControlRef.current.nextMedia()
            track(ANALYTICS_EVENTS.SWIPE_UP, getCurrentPlaylistName())
        },
        onSwipedDown: () => {
            videoControlRef.current.previousMedia()
            track(ANALYTICS_EVENTS.SWIPE_DOWN, getCurrentPlaylistName())
        },
        onSwipedRight: () => {
            setPlayListLiked(dispatch)
        }
    })

    return displayMain()


}